import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";
import MapsProvider from "@/components/MapsProvider";
// import ProtectedRoute from "@/components/ProtectedRoute";
// import RoleRoute from "@/components/RoleRoute";
import LandingPage from "@/pages/LandingPage";
// import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/pages/AuthCallback";
// import HomePage from "@/pages/HomePage";
// import BookingFlow from "@/pages/BookingFlow";
// import MapBooking from "@/pages/MapBooking";
// import BookingConfirm from "@/pages/BookingConfirm";
// import TrackBooking from "@/pages/TrackBooking";
// import ReviewBooking from "@/pages/ReviewBooking";
// import HelpSupport from "@/pages/HelpSupport";
// import Referral from "@/pages/Referral";
// import MessDetection from "@/pages/MessDetection";
// import BookingsHistory from "@/pages/BookingsHistory";
// import ProfilePage from "@/pages/ProfilePage";
// import WorkerLogin from "@/pages/WorkerLogin";
// import WorkerRegister from "@/pages/WorkerRegister";
// import AdminLogin from "@/pages/AdminLogin";
// import WorkerLayout from "@/components/WorkerLayout";
// import AdminLayout from "@/components/AdminLayout";
// import WorkerDashboard from "@/pages/worker/WorkerDashboard";
// import WorkerJobs from "@/pages/worker/WorkerJobs";
// import WorkerActiveJob from "@/pages/worker/WorkerActiveJob";
// import WorkerEarnings from "@/pages/worker/WorkerEarnings";
// import WorkerProfile from "@/pages/worker/WorkerProfile";
// import WorkerReviews from "@/pages/worker/WorkerReviews";
// import AdminDashboard from "@/pages/admin/AdminDashboard";
// import AdminLiveOps from "@/pages/admin/AdminLiveOps";
// import AdminWorkers from "@/pages/admin/AdminWorkers";
// import AdminBookings from "@/pages/admin/AdminBookings";
// import AdminAnalytics from "@/pages/admin/AdminAnalytics";
// import AdminServices from "@/pages/admin/AdminServices";
// import AdminTickets from "@/pages/admin/AdminTickets";
// import AdminReviews from "@/pages/admin/AdminReviews";
// import AdminAICenter from "@/pages/admin/AdminAICenter";
// import AdminFinance from "@/pages/admin/AdminFinance";

function AppRouter() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Check URL fragment for session_id synchronously during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<LandingPage />} />

      {/* All app routes disabled — landing page only.
      <Route path="/login" element={<LoginPage />} />
      <Route path="/worker/login" element={<WorkerLogin />} />
      <Route path="/worker/register" element={<WorkerRegister />} />
      <Route path="/admin/login" element={<AdminLogin />} />

      <Route path="/worker-login" element={<Navigate to="/worker/login" replace />} />
      <Route path="/worker-register" element={<Navigate to="/worker/register" replace />} />
      <Route path="/admin-login" element={<Navigate to="/admin/login" replace />} />

      <Route path="/home" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
      <Route path="/dashboard" element={<Navigate to="/home" replace />} />
      <Route path="/booking/:serviceId" element={<ProtectedRoute><BookingFlow /></ProtectedRoute>} />
      <Route path="/book" element={<ProtectedRoute><MapBooking /></ProtectedRoute>} />
      <Route path="/book/confirm" element={<ProtectedRoute><BookingConfirm /></ProtectedRoute>} />
      <Route path="/track/:bookingId" element={<ProtectedRoute><TrackBooking /></ProtectedRoute>} />
      <Route path="/review/:bookingId" element={<ProtectedRoute><ReviewBooking /></ProtectedRoute>} />
      <Route path="/help" element={<ProtectedRoute><HelpSupport /></ProtectedRoute>} />
      <Route path="/referral" element={<ProtectedRoute><Referral /></ProtectedRoute>} />
      <Route path="/mess-detection" element={<ProtectedRoute><MessDetection /></ProtectedRoute>} />
      <Route path="/bookings" element={<ProtectedRoute><BookingsHistory /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />

      <Route path="/worker" element={<RoleRoute role="worker" loginPath="/worker/login"><WorkerLayout /></RoleRoute>}>
        <Route index element={<WorkerDashboard />} />
        <Route path="dashboard" element={<WorkerDashboard />} />
        <Route path="jobs" element={<WorkerJobs />} />
        <Route path="jobs/:bookingId" element={<WorkerActiveJob />} />
        <Route path="earnings" element={<WorkerEarnings />} />
        <Route path="reviews" element={<WorkerReviews />} />
        <Route path="profile" element={<WorkerProfile />} />
      </Route>

      <Route path="/admin" element={<RoleRoute role="master_admin" loginPath="/admin/login"><AdminLayout /></RoleRoute>}>
        <Route index element={<AdminDashboard />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="live-ops" element={<AdminLiveOps />} />
        <Route path="workers" element={<AdminWorkers />} />
        <Route path="bookings" element={<AdminBookings />} />
        <Route path="services" element={<AdminServices />} />
        <Route path="reviews" element={<AdminReviews />} />
        <Route path="tickets" element={<AdminTickets />} />
        <Route path="ai-center" element={<AdminAICenter />} />
        <Route path="finance" element={<AdminFinance />} />
        <Route path="analytics" element={<AdminAnalytics />} />
      </Route>
      */}

      {/* Catch-all → landing */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <I18nProvider>
          <MapsProvider>
            <div className="bg-pattern" />
            <AppRouter />
            <Toaster position="top-center" richColors />
          </MapsProvider>
        </I18nProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
